import { ArrowRight, Boxes, PencilRuler, Sparkles } from 'lucide-react';

type MoldeOneFlow = 'editar-molde' | 'aplicar-arte';

type HubProps = {
  onSelect: (flow: MoldeOneFlow) => void;
};

export function Hub({ onSelect }: HubProps) {
  return (
    <div className="flex-1 overflow-y-auto bg-navy-950 px-4 py-4 text-white">
      <div className="space-y-2">
        <div className="flex items-center gap-3 px-1 pb-1">
          <div className="rounded-2xl bg-yellow-500/15 p-2 text-yellow-400">
            <Boxes size={16} />
          </div>
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.22em] text-yellow-400">MoldeOne v3</div>
            <div className="mt-0.5 text-base font-semibold text-white">Escolha o fluxo</div>
          </div>
        </div>

        <div className="grid gap-2">
          <button
            onClick={() => onSelect('editar-molde')}
            className="group rounded-[18px] border border-yellow-600/40 bg-yellow-500 px-4 py-3.5 text-left text-navy-950 transition-colors hover:bg-yellow-400"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex min-w-0 items-start gap-3">
                <div className="rounded-2xl bg-navy-950/10 p-2">
                  <PencilRuler size={16} />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-navy-900/70">Principal</div>
                  <div className="mt-1 text-xl font-semibold">Editar Molde</div>
                </div>
              </div>
              <ArrowRight size={18} className="mt-1 opacity-70 transition-transform group-hover:translate-x-1" />
            </div>
          </button>

          <button
            onClick={() => onSelect('aplicar-arte')}
            className="group rounded-[18px] border border-cyan-700/30 bg-navy-900 px-4 py-3.5 text-left text-white transition-colors hover:bg-navy-800"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex min-w-0 items-start gap-3">
                <div className="rounded-2xl bg-cyan-500/10 p-2 text-cyan-300">
                  <Sparkles size={16} />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-cyan-300">Origem da arte</div>
                  <div className="mt-1 text-xl font-semibold">Aplicar Arte</div>
                </div>
              </div>
              <ArrowRight size={18} className="mt-1 text-cyan-200 opacity-70 transition-transform group-hover:translate-x-1" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
